<template>
    <main class="mt-3 lg:relative">
        <div
            class="w-full max-w-screen-xl px-4 pt-16 pb-20 mx-auto text-center sm:mt-12 sm:px-6 md:mt-16 lg:mt-20 xl:mt-28 lg:py-48 lg:text-left"
        >
            <div class="px-4 lg:w-1/2 sm:px-8 xl:pr-16">
                <h2
                    class="text-4xl font-extrabold leading-10 tracking-tight text-blue-600 sm:text-5xl sm:leading-none md:text-6xl lg:text-5xl xl:text-6xl"
                >
                    Créez votre Business plan
                </h2>
                <p
                    class="max-w-md mx-auto mt-3 text-lg text-gray-500 sm:text-xl md:mt-5 md:max-w-3xl"
                >
                    Un guide interactif pour vous simplifier la création de
                    votre business plan.
                </p>
                <div class="mt-10 sm:flex sm:justify-center lg:justify-start">
                    <div class="rounded-md shadow">
                        <span
                            class="flex items-center justify-center w-full px-8 py-3 text-base font-medium leading-6 text-white transition duration-150 ease-in-out bg-blue-600 border border-transparent rounded-md cursor-pointer hover:bg-blue-700 focus:outline-none focus:border-blue-700 focus:shadow-outline-blue md:py-4 md:text-lg md:px-10"
                            @click="nextLink"
                        >
                            {{ auth.button }}</span
                        >
                    </div>
                    <div class="mt-3 rounded-md shadow sm:mt-0 sm:ml-3">
                        <router-link
                            target="_blank"
                            :to="{ name: 'guide_pratique' }"
                            class="flex items-center justify-center w-full px-8 py-3 text-base font-medium leading-6 text-blue-600 transition duration-150 ease-in-out bg-white border border-transparent rounded-md hover:text-blue-600 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue md:py-4 md:text-lg md:px-10"
                        >
                            Guide Pratique
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
        <div
            class="relative w-full h-64 sm:h-72 md:h-96 lg:absolute lg:inset-y-0 lg:right-0 lg:w-1/2 lg:h-full"
        >
            <img
                src="../assets/Business Plan-amico.svg"
                class="w-10/12"
                alt="business plan poster"
            />
        </div>
    </main>
</template>

<script>
import isEmpty from "lodash/isEmpty";
import { mapGetters } from "vuex";
export default {
    components: {},
    data() {
        return {
            auth: {
                button: "Inscription",
                path: ""
            },
            uid: null
        };
    },
    created() {
        this.init();
        this.$store.watch(
            state => {
                return state.user.user;
            },
            () => {
                this.init();
            }
        );
    },

    methods: {
        nextLink() {
            if (this.auth.path === "business_plan_version") {
                this.$router.push({
                    name: "business_plan_version",
                    params: { uid: `${this.$store.state.user.bpiId}` }
                });
            } else if (this.auth.path === "profils_des_investisseurs") {
                this.$router.push({
                    name: `${this.$store.state.user.currentStep}`,
                    params: { uid: `${this.uid}` }
                });
            } else {
                this.$router.push({
                    name: "rm",
                    params: { uid: `${this.$store.state.user.bpiId}` },
                    query: { inscription: true }
                });
            }
        },
        init() {
            if (this.isAuth) {
                if (this.user.bpis.length === 0) {
                    this.auth.button = "Créer Votre BPI";
                    this.auth.path = "business_plan_version";
                } else {
                    this.auth.button = "Mon BPI";
                    this.auth.path = "profils_des_investisseurs";
                    this.uid = this.user.bpis[0].id;
                }
            }
        }
    },
    computed: {
        ...mapGetters("user", { user: "getUser" }),
        isAuth() {
            return !isEmpty(this.user);
        }
    }
};
</script>

<style></style>
